<div class="space-y-2">
  <label [attr.for]="id" class="block text-sm font-medium text-slate-700">
    {{ label() }}
    @if (required()) {
      <span class="text-red-500" aria-hidden="true">*</span>
    }
  </label>

  <div class="relative">
    @if (prefix()) {
      <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3.5 text-sm text-slate-400">
        {{ prefix() }}
      </span>
    }

    <input
      [id]="id"
      [type]="type()"
      [formControl]="control()"
      [placeholder]="placeholder()"
      [attr.inputmode]="type() === 'number' ? 'decimal' : null"
      [attr.aria-invalid]="invalid()"
      [readOnly]="readonly()"
      [class.bg-white]="!readonly()"
      [class.text-slate-900]="!readonly()"
      [class.bg-slate-100]="readonly()"
      [class.text-slate-600]="readonly()"
      [class.cursor-not-allowed]="readonly()"
      class="h-11 w-full rounded-lg border px-4 text-[15px]
             placeholder:text-slate-400 focus:outline-none focus:ring-2
             focus:ring-indigo-500/30 [appearance:textfield]
             [&::-webkit-inner-spin-button]:appearance-none
             [&::-webkit-outer-spin-button]:appearance-none"
      [class.pl-8]="!!prefix()"
      [class.pr-16]="!!suffix()"
      [class]="invalid()
        ? 'border-red-400 focus:border-red-500'
        : 'border-slate-200 focus:border-indigo-500'"
    />

    @if (suffix()) {
      <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3.5 text-sm text-slate-400">
        {{ suffix() }}
      </span>
    }
  </div>

  @if (invalid()) {
    <p class="text-xs font-medium text-red-600" role="alert">{{ errorText() }}</p>
  } @else if (hint()) {
    <p class="text-xs text-slate-500">{{ hint() }}</p>
  }
</div>
